import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { useWishlist } from "@/context/WishlistContext";

export default function Favoritos() {
  const { ids } = useWishlist();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/wishlist").then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, [ids]);

  return (
    <div className="max-w-[1500px] mx-auto px-5 md:px-10 py-14 min-h-[60vh]">
      <div className="text-[11px] uppercase tracking-[0.2em] text-[#B89C65] mb-4">Minha seleção</div>
      <h1 className="font-serif font-light text-5xl md:text-6xl tracking-tight text-[#1A1A1A] mb-12">Lista de desejos</h1>

      {loading ? (
        <p className="text-[#5C5B59]">Carregando…</p>
      ) : products.length === 0 ? (
        <div data-testid="empty-wishlist" className="border border-[#E6E5E1] py-24 text-center">
          <Heart size={40} strokeWidth={1} className="mx-auto text-[#1A1A1A]/20" />
          <p className="font-serif text-2xl text-[#1A1A1A] mt-5">Você ainda não favoritou nenhuma peça</p>
          <p className="text-[#5C5B59] mt-2">Toque no coração das peças que amar para guardá-las aqui.</p>
          <Link to="/loja" className="inline-block mt-8 bg-[#1A1A1A] text-[#F8F7F4] px-8 py-4 text-[11px] uppercase tracking-[0.15em] hover:bg-[#B89C65] transition-colors">
            Explorar a loja
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-14">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
